import { UploadViewComponent } from '../../views/upload-view/upload-view.component';
import { AccessMenuTool } from './access-menu-tool';

export class UploadAccessMenuTool extends AccessMenuTool {
  public constructor() {
    super('Uploads', 'cloud-upload', UploadViewComponent, 400);
  }
}
